var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Spec
 * http://www.google.com/design/spec/patterns/navigation-drawer.html#
 * http://www.google.com/design/spec/patterns/app-structure.html#app-structure-top-level-navigation-strategies
 * http://www.google.com/design/spec/layout/structure.html#structure-side-nav
 */

import React from 'react';
import classnames from 'classnames';
import { Logo, Button, Menu, ChevronRight } from '../icon/';

// height is menu item height.
// we need it in JS instead CSS to calculate overall height of submenu.
// e.g. 10 items in submenu => height = 10 * 48 = 480px.
// we have to know the overall height to animate between height 0 and height 480.
// unfortunately we cannot animate between height 0 and height: auto.
// that's why we cannot set the height in css.
var height = 44;

var NavigationGroup = function (_React$Component) {
  _inherits(NavigationGroup, _React$Component);

  function NavigationGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavigationGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavigationGroup.__proto__ || Object.getPrototypeOf(NavigationGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.toggleOpen = function (event) {
      event.stopPropagation();
      _this.setState({
        isOpen: !_this.state.isOpen
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavigationGroup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var children = Array.prototype.slice.call(this.listNode.children);
      this.setState({
        isOpen: children.find(function (child) {
          return child.classList.contains('active');
        })
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var children = this.props.children;

      var maxHeight = isOpen ? React.Children.count(children) * height : 0;
      return React.createElement(
        'li',
        { className: 'mdc-Navigation-group' },
        React.createElement(
          'span',
          { className: classnames('mdc-Navigation-group-title', { 'mdc-Navigation-group--opened': isOpen }), onClick: this.toggleOpen },
          this.props.title,
          React.createElement(ChevronRight, { className: 'mdc-Navigation-group-icon' })
        ),
        React.createElement(
          'ul',
          { className: 'mdc-Navigation-group-links', ref: function ref(node) {
              _this2.listNode = node;
            }, style: { maxHeight: maxHeight } },
          children
        )
      );
    }
  }]);

  return NavigationGroup;
}(React.Component);

/**
 * Navigation
 */


var Navigation = function (_React$Component2) {
  _inherits(Navigation, _React$Component2);

  function Navigation() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, Navigation);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {
      visible: false

      /**
       * Hide overlay
       */
    }, _this3.close = function () {
      _this3.setState({
        visible: false
      });
    }, _this3.closeOverlay = function (event) {
      _this3.close();
      event.preventDefault();
    }, _this3.open = function () {
      _this3.setState({
        visible: true
      });
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  /**
   * Open overlay
   */


  _createClass(Navigation, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'mdc-Navigation' },
        React.createElement(
          'nav',
          { className: classnames('mdc-Navigation-sidebar', { 'is-visible': this.state.visible }) },
          React.createElement(
            'div',
            { className: 'mdc-Navigation-logo' },
            React.createElement(
              'a',
              { href: '#', onClick: this.close },
              React.createElement(Logo, { fill: '#A7A5A5' })
            )
          ),
          React.createElement(
            'ul',
            { className: 'mdc-Navigation-links', onClick: this.close },
            this.props.children
          )
        ),
        React.createElement(
          'div',
          { className: 'mdc-Navigation-hamburger' },
          React.createElement(
            Button,
            { onClick: this.open },
            React.createElement(Menu, null)
          )
        ),
        React.createElement('div', {
          className: classnames('mdc-Navigation-overlay', {
            'is-visible': this.state.visible
          }),
          onClick: this.closeOverlay,
          onTouchEnd: this.closeOverlay
        })
      );
    }
  }]);

  return Navigation;
}(React.Component);

Navigation.Group = NavigationGroup;

export default Navigation;


//////////////////
// WEBPACK FOOTER
// ../es/js/navigation/index.js
// module id = 119
// module chunks = 0